import { RouteNames } from "@/router/RouteNames";
import { Router } from "vue-router"

// Take the user to the Error page and log the error int the console
// Since exceptions don't have strict types i've left it as any since we are just pushing to the console
export const displayErrorPage = (router: Router, error: any) => {
    console.error(error);
    router.push({ name: RouteNames.ErrorPage });
}